export default "__VITE_ASSET__BHVjIS8$__"